var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8203 26.6657V3.33236C30.8203 1.49902 29.3203 -0.000976562 27.487 -0.000976562H4.15365C2.32031 -0.000976562 0.820312 1.49902 0.820312 3.33236V26.6657C0.820312 28.499 2.32031 29.999 4.15365 29.999H27.487C29.3203 29.999 30.8203 28.499 30.8203 26.6657ZM10.6536 18.299L14.1536 22.5157L19.3203 15.8657C19.6536 15.4324 20.3203 15.4324 20.6536 15.8824L26.5036 23.6824C26.9203 24.2324 26.5203 25.0157 25.837 25.0157H5.85365C5.15365 25.0157 4.77031 24.2157 5.20365 23.6657L9.35365 18.3324C9.67031 17.899 10.3036 17.8824 10.6536 18.299Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.2eb094c63e818d681a5b331a609291b3.svg";
export { ForwardRef as ReactComponent };